// extracted by mini-css-extract-plugin
module.exports = {"form":"custom-search-box_form__kSuRd","input":"custom-search-box_input__gTnOI"};